import React from "react";
import { isChatbotEnabled, openChatbot } from "./chatbot-widget";
import chatIconUrl from "../../public/assets/images/chatbot/falcon-chat-ic.svg";

/*******************
  @Purpose : "Ask" nav button (icon + label) that opens the chatbot widget.
             Unlike ChatbotButton it does not preload the widget; it is
             loaded on the first click.
  @Parameter : {className} extra classes for the surrounding nav styles
  *******************/
function ChatbotAskButton({ className = "" }) {
  return (
    <button
      type="button"
      className={`chatbot-ask-button ${className}`.trim()}
      aria-label="Ask Falcon"
      disabled={!isChatbotEnabled()}
      onClick={openChatbot}
    >
      <span className="icon">
        <img src={chatIconUrl} alt="" />
      </span>
      Ask
    </button>
  );
}

export default ChatbotAskButton;
